/* eslint-disable */
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';
import { UtilsService } from 'src/app/services/utils.service';
import { ApiServiceOld } from '../api-old.service';
import { CONSTANTS } from '../config.service';
import { DailySurveyService } from '../daily-survey.service';
import { DateTimeService } from '../date-time/date-time.service';
import { LoggerService } from '../logger.service';
import { PrefsService } from '../prefs.service';
import { ProxySurveyService } from '../proxy-survey.service';
import { PubSubService } from '../pub-sub.service';
import { SenderSurveyService } from '../sender-survey.service';
import { SignupSurveyService } from '../signup-survey.service';
import { TripSurveyService } from '../trip-survey.service';
import { ClearService } from './clear.service';
import { LoadService } from './load.service';
import { MatcherService } from './matcher.service';
import { SetterService } from './setter.service';
import { TimeLoggerService } from './time-logger.service';

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  path = [];

  constructor(
    private toastCtrl: ToastController,
    public translate: TranslateService,
    private logger: LoggerService,
    private prefs: PrefsService,
    private pubSub: PubSubService,
    private clear: ClearService,
    private load: LoadService,
    private matcher: MatcherService,
    private signupSurvey: SignupSurveyService,
    private tripSurvey: TripSurveyService,
    private dailySurvey: DailySurveyService,
    private proxySurvey: ProxySurveyService,
    private senderSurvey: SenderSurveyService,
    private setter: SetterService,
    private dateTime: DateTimeService,
    private timeLogger: TimeLoggerService,
    private api: ApiServiceOld,
    private utils: UtilsService
  ) {}

  async presentToastSurveyComplete() {
    const toast = await this.toastCtrl.create({
      message: this.translate.instant('SURVEY_TOAST_COMPLETE'),
      duration: 2000,
      position: 'top',
      cssClass: 'toast-custom'
    });
    await toast.present();
  }

  setCallCenterAnswered(surveyType, surveyData) {
    let callCenterIP;

    return new Promise<void>((resolve, reject) => {
      // if we're on a device, it can't be call center, and it never could have been call center, so no need to clear
      if (CONSTANTS.IS_DEVICE) {
        resolve();
      }

      this.prefs
        .getPromise('callCenterIP')
        .then((res) => {
          callCenterIP = res;
          this.api.post(CONSTANTS.ipPath, {}).subscribe((ip) => {
            if (ip.hasOwnProperty('ip_address') && ip['ip_address'] == callCenterIP) {
              surveyData.callCenterAnswered = 1;
              this.updateSurvey(surveyType, surveyData).then(() => resolve());
            } else {
              resolve();
            }
          });
        })
        .catch(() => {
          // if we don't have a call center IP, move on
          resolve();
        });
    });
  }

  setCallCenterAnswered_(surveyType, surveyData) {
    return this.prefs
      .getPromise('callCenterUA')
      .then((callCenterUA) => {
        if (navigator.userAgent == callCenterUA) {
          surveyData.callCenterAnswered = 1;
          return this.updateSurvey(surveyType, surveyData);
        } else {
          return Promise.resolve();
        }
      })
      .catch(() =>
        // if we error out getting ip, just return
        Promise.resolve()
      );
  }

  goToSurveyPage(surveyType, surveyData) {
    return new Promise((resolve, reject) => {
      this.prefs.getPromiseOrDefault(CONSTANTS.longDistanceModeKey).then((isLd) => {
        const page = surveyData.lastPage;

        let paramsRoster = [];
        let paramsMap = [];
        const paramsSurvey = [surveyType, surveyData.id, surveyData.lastPage];

        let rosterTarget = isLd
          ? 'trips-ld'
          : CONSTANTS.IS_BROWSERMOVE
            ? 'roster'
            : surveyType === CONSTANTS.surveyTypes.TRIP
              ? 'trips'
              : 'dashboard';
        const mapTarget = isLd ? 'map-region' : CONSTANTS.IS_BROWSERMOVE ? 'roster' : 'map-route';

        // if user still needs to report trips, send them directly to diary page. Don't do this for browserMove
        if (
          page === 'end' &&
          CONSTANTS.IS_BROWSERMOVE === false &&
          (surveyType === CONSTANTS.surveyTypes.DAILY || CONSTANTS.surveyTypes.PROXY) &&
          surveyData.hasOwnProperty('needsToAddTrips') &&
          surveyData.needsToAddTrips === 1
        ) {
          rosterTarget = 'trips';
        }

        if (rosterTarget === 'trips') {
          paramsRoster = [surveyData.subjectPersonId, surveyData.surveyDate];
        }

        if (mapTarget === 'map-route' || mapTarget === 'map-region') {
          paramsMap = [surveyData.id, surveyData.subjectPersonId];
        }

        this.logger.log(`In goToSurveyPage id: ${surveyData.id}, page: ${surveyData.lastPage}`, MSRemoteLoggerCategory.SURVEY_BRANCH_SERVICE);

        if ('start' === page) {
          if (surveyType === CONSTANTS.surveyTypes.TRIP) {
            resolve(['/' + mapTarget].concat(paramsMap));
          } else if (surveyType === CONSTANTS.surveyTypes.DAILY || surveyType === CONSTANTS.surveyTypes.PROXY) {
            resolve(['/' + rosterTarget].concat(paramsRoster));
          }
        } else if ('end' === page) {
          this.setCallCenterAnswered(surveyType, surveyData).then(() => {
            if (surveyType === CONSTANTS.surveyTypes.SIGNUP) {
              resolve(['/persons-setup']);
            } else {
              this.timeLogger.send();
              if (CONSTANTS.IS_DEVICE) {
                this.presentToastSurveyComplete();
              }
              resolve(['/' + rosterTarget].concat(paramsRoster));
            }
          });
        } else {
          resolve(['/survey'].concat(paramsSurvey));
        }
      });
    });
  }

  getSurveyService(surveyType) {
    switch (surveyType) {
      case CONSTANTS.surveyTypes.TRIP:
        return this.tripSurvey;
      case CONSTANTS.surveyTypes.DAILY:
        return this.dailySurvey;
      case CONSTANTS.surveyTypes.SIGNUP:
        return this.signupSurvey;
      case CONSTANTS.surveyTypes.PROXY:
        return this.proxySurvey;
      default:
        throw 'Unknown survey type ' + surveyType;
    }
  }

  // TODO make this generally available? Some pages handle this themselves
  updateSurvey(surveyType, surveyData) {
    return this.getSurveyService(surveyType).update(surveyData);
  }

  updateSurveyNav = function (surveyType, surveyData) {
    return this.getSurveyService(surveyType).updateSurveyNav(surveyData);
  };

  addPageToPath = function (surveyData, pageFrom) {
    if (surveyData.path === null) {
      return pageFrom;
    } else {
      this.path = surveyData.path.split(',');
      this.path.push(pageFrom);
      return this.path.join();
    }
  };

  getPageIndex = function (pages, pageDef, surveyData) {
    let i;
    let pageName = pageDef;
    const lap = surveyData.lap;
    const maxLapIndex = surveyData.maxLapIndex;
    let nextLap;
    // HACK_LAP
    if (pageDef !== undefined && pageDef.hasOwnProperty('lapOffset')) {
      // e.g. {page: 'p0', lapOffset: 1}
      if (!pageDef.page || pageDef.lapOffset === undefined) {
        throw new Error('Cannot go to page ' + pageDef);
      }
      if (pageDef.lapOffset < 0) {
        throw new Error('Cannot go to a previous loop for ' + pageDef);
      }
      if (!Number.isInteger(lap)) {
        throw new Error('Cannot go to a lapOffset with no lap ' + pageDef + ', ' + lap);
      }
      nextLap = lap + pageDef.lapOffset;
      if (nextLap > maxLapIndex) {
        throw new Error('Cannot go beyond max laps ' + nextLap + '>' + surveyData.maxLapIndex + '(' + pageDef + ')');
      }
      pageName = pageDef.page + 'L' + nextLap;
    }

    for (i = 0; i < pages.length; i++) {
      if (pages[i].name === pageName) {
        return i;
      }
    }
    return -1;
  };

  findNextPage(pages, candidateIndex, surveyData, surveyType?) {
    const candidate = pages[candidateIndex];
    let hiddenNextIndex;
    surveyData.lap = candidate.lap;
    surveyData.maxLapIndex = candidate.maxLapIndex;

    return this.matcher.show(candidate, surveyData).then((show) => {
      if (show) {
        return Promise.resolve(candidate);
      } else if (candidate.hiddenNext) {
        let hiddenNextPage;
        if (candidate.hiddenNext.hasOwnProperty('page')) {
          hiddenNextIndex = this.getPageIndex(pages, candidate.hiddenNext.page, surveyData);
          hiddenNextPage = candidate.hiddenNext.page;
        } else {
          hiddenNextIndex = this.getPageIndex(pages, candidate.hiddenNext, surveyData);
          hiddenNextPage = candidate.hiddenNext;
        }

        if (hiddenNextIndex <= candidateIndex) {
          throw 'Skipping backwards not supported (' + candidateIndex + ' to ' + hiddenNextIndex + ') from ' + pages[candidateIndex].name;
        }

        if (candidate.hiddenNext.hasOwnProperty('clear') && candidate.hiddenNext.clear === false) {
          // we might pre-pop entire sections of a survey and then want to skip over it
          return this.findNextPage(pages, hiddenNextIndex, surveyData, surveyType);
        } else {
          return this.processSkippedPages(pages, candidateIndex, hiddenNextIndex, surveyData).then(() =>
            this.findNextPage(pages, hiddenNextIndex, surveyData, surveyType)
          );
        }
      } else {
        return this.processSkippedPage(candidate, surveyData).then(() =>
          this.findNextPage(pages, ++candidateIndex, surveyData, surveyType)
        );
      }
    });
  }

  findFuturePages(surveyType, pageFrom, surveyData) {
    const clonedData = { ...surveyData }; // shallow copy should work for this data
    const looper = (startPage, output) =>
      this.getNextPage(surveyType, startPage.name, clonedData).then((page) => {
        output.push(page.name);
        if (page.name === 'end' || page.name.includes('DISQUALIFIED')) {
          this.logger.debug(`future looper found ${output}`, MSRemoteLoggerCategory.SURVEY_BRANCH_SERVICE);
          return output;
        } else {
          return looper(page, output);
        }
      });

    if (pageFrom.name === 'end' || pageFrom.name.includes('DISQUALIFIED')) {
      return Promise.resolve([]);
    }

    delete clonedData.id; // just in case - don't want clonedData saved
    this.logger.debug(`future looper starting from ${pageFrom.name}`, MSRemoteLoggerCategory.SURVEY_BRANCH_SERVICE);
    return looper(pageFrom, []);
  }

  processSkippedPages(pages, candidateIndex, hiddenNextIndex, surveyData) {
    const promises = [];
    for (let i = candidateIndex; i < hiddenNextIndex; i++) {
      const pageToProcess = pages[i];
      promises.push(() => this.processSkippedPage(pageToProcess, surveyData));
    }
    return this.utils.runPromisesSerially(promises);
  }

  processSkippedPage(page, surveyData) {
    this.logger.debug(`Processing skipped page ${page.name}`, MSRemoteLoggerCategory.SURVEY_BRANCH_SERVICE);
    this.clear.clearVars(page, surveyData);
    return this.setter.set(page.setter, surveyData);
  }

  findJumpPage(pages, pageFrom, surveyData) {
    let confirmConstants;
    let confirmed;
    let confirmedState;
    let errorConstants;
    let spurious;
    let noStop;
    let missedStops;
    let errorState;
    let nextPageName;
    let nextPageIndex;

    if ('CONFIRM' === pageFrom) {
      confirmConstants = CONSTANTS.surveyPages.CONFIRM;
      confirmed = confirmConstants.answers.CONFIRMED;
      confirmedState = surveyData[confirmConstants.questionName];
      if (confirmed === confirmedState) {
        nextPageName = 'end';
      }
    } else if ('ERROR' === pageFrom) {
      errorConstants = CONSTANTS.surveyPages.ERROR;
      spurious = errorConstants.answers.ERROR_NOT_MOVING;
      noStop = errorConstants.answers.ERROR_STILL_TRAVELLING;
      missedStops = errorConstants.answers.ERROR_OTHER_STOPS;
      errorState = surveyData[errorConstants.questionName];
      if (spurious === errorState) {
        nextPageName = 'end';
      } else if (noStop === errorState) {
        nextPageName = 'merge';
      } else if (missedStops === errorState) {
        nextPageName = 'split';
      }
    }

    nextPageIndex = this.getPageIndex(pages, nextPageName, surveyData);

    if (nextPageName === 'merge' || nextPageName === 'split') {
      // hack to allow branch out of survey
      return Promise.resolve({ name: nextPageName });
    } else if (-1 === nextPageIndex) {
      // survey may not have that page...
      return Promise.reject(null);
    } else {
      return Promise.resolve(pages[nextPageIndex]);
    }
  }

  getNextPage(surveyType, pageFrom, surveyData) {
    const pages = this.load.getSurveyPages(surveyType);
    const pageFromIndex = this.getPageIndex(pages, pageFrom, surveyData);

    this.logger.log('Getting next page from ' + pageFrom, MSRemoteLoggerCategory.SURVEY_BRANCH_SERVICE);
    // jump or walk to next page...
    return this.findJumpPage(pages, pageFrom, surveyData).catch(() => this.findNextPage(pages, pageFromIndex + 1, surveyData, surveyType));
  }

  goToNextPage(surveyType, pageFrom, surveyData) {
    const started = pageFrom === 'start' && (surveyData.lastPage === null || surveyData.lastPage === 'start');
    const restarted = pageFrom === 'start' && surveyData.lastPage === 'end';
    const resumed = pageFrom === 'start' && !restarted && !started;
    let finished = false;
    let pageToName;

    // if resuming mid-survey, go directly to that page
    if (resumed) {
      //this.logger.log(`goToNextPage(${surveyType}, ${pageFrom}, ${JSON.stringify(surveyData)}) calling goToSurveyPage`)
      return this.goToSurveyPage(surveyType, surveyData);
    }

    // if start/restart, reset path variables
    if (started || restarted) {
      surveyData.path = 'start';
      surveyData.lastPage = 'start';
    }

    return this.clear
      .clearExtraAnswers(surveyType, pageFrom, surveyData)
      .then(() => {
        const pages = this.load.getSurveyPages(surveyType);
        const pageFromIndex = this.getPageIndex(pages, pageFrom, surveyData);
        const pageToSet = pages[pageFromIndex];

        if (pageToSet.setter) {
          return this.setter.set(pageToSet.setter, surveyData).then(() => this.getNextPage(surveyType, pageFrom, surveyData));
        } else {
          return this.getNextPage(surveyType, pageFrom, surveyData);
        }
      })
      .then((pageTo) => {
        pageToName = pageTo.name;
        this.logger.log('got next page', MSRemoteLoggerCategory.SURVEY_BRANCH_SERVICE, pageToName);

        if (pageToName === 'end') {
          finished = true;
          surveyData.complete = 1;
        } else {
          surveyData.complete = 0;
        }

        // resetting queued any time the user navs through a survey page.
        // this lets partial surveys make their way to the server
        // the surveys aren't actually put in the queue until:
        // 1) a survey is completed
        // 2) a trip ends
        // 3) we reach the 8 hour interval
        surveyData.queued = 0;

        surveyData.path = this.addPageToPath(surveyData, pageToName);
        surveyData.lastPage = pageToName;

        if (started) {
          surveyData.firstStarted = this.dateTime.getNowSeconds();
        }

        if (restarted) {
          surveyData.lastStarted = this.dateTime.getNowSeconds();
        }
        return this.findFuturePages(surveyType, pageTo, surveyData);
      })
      .then((futurePages) => {
        surveyData.futurePath = futurePages.join(',');
        this.logger.debug(`futurePath set to ${surveyData.futurePath}`, MSRemoteLoggerCategory.SURVEY_BRANCH_SERVICE);

        return this.updateSurvey(surveyType, surveyData).then((ignoredResult) => {
          // always upload signup survey
          if (surveyType === CONSTANTS.surveyTypes.SIGNUP) {
            this.senderSurvey.uploadSignupSurvey(true);
          }

          // if (pageTo.hasOwnProperty('params') && pageTo.params.uploadPartialSignupSurvey === true) {
          //     this.senderSurvey.uploadSignupSurvey(true);
          // }

          return this.goToSurveyPage(surveyType, surveyData);
        });
      })
      .then((res) => {
        this.logger.log('Returned from updating survey:', MSRemoteLoggerCategory.SURVEY_BRANCH_SERVICE, res as string[]);
        if (restarted) {
          this.pubSub.publish(CONSTANTS.EVENTS.surveyRestarted);
          // only emit surveyFinished event if mobile app. If browser, let the roster queue and send
        } else if (finished && surveyType !== CONSTANTS.surveyTypes.SIGNUP && CONSTANTS.IS_DEVICE) {
          this.pubSub.publish(CONSTANTS.EVENTS.surveyFinished);
        }

        return res;
      });
  }

  removePageFromPath(surveyData) {
    if (surveyData.path === 'start') {
      return;
    } else {
      this.path = surveyData.path.split(',');
      this.path.pop();
      return this.path.join();
    }
  }

  getLastPageName(surveyData) {
    this.path = surveyData.path.split(',');
    return this.path[this.path.length - 1];
  }

  previousPageIsStart(surveyData) {
    const path = surveyData.path.split(',');
    return path.length >= 2 && path[path.length - 2] === 'start';
  }

  goToPreviousPage(surveyType, surveyData) {
    surveyData.path = this.removePageFromPath(surveyData);
    surveyData.lastPage = this.getLastPageName(surveyData);

    return this.updateSurveyNav(surveyType, surveyData).then(() => this.goToSurveyPage(surveyType, surveyData));
  }
}
